// <s-cookie-preferences> — footer "Préférences en matière de cookies" link.
// A button inside targets the host with command="--show-preferences". Opens Shopify's cookie
// banner preferences when the store uses it (window.privacyBanner); otherwise goes to the
// privacy policy passed in data-fallback-url.
// When the cookie banner injects its own "cookie preferences" link into the Légal list
// ([data-footer-legal]), this item hides itself so the link appears once; links in that list
// that share a URL are also reduced to one.
class SCookiePreferences extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    this.addEventListener('command', (event) => this.#onCommand(event), { signal: this.#ac.signal });

    const list = this.closest('[data-footer-legal]');
    if (!list) return;
    this.#dedupe(list);
    this.#observer = new MutationObserver(() => this.#dedupe(list));
    this.#observer.observe(this.closest('footer') || list, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #dedupe(list) {
    const seen = new Set();
    for (const link of list.querySelectorAll('a[href]')) {
      const item = link.closest('li') || link;
      const key = link.href.split('#')[0];
      if (seen.has(key)) item.hidden = true;
      else seen.add(key);
    }

    const ownItem = this.closest('li') || this;
    const scope = this.closest('footer') || list;
    const injected = [...scope.querySelectorAll('a, button')].some(
      (el) => !this.contains(el) && !el.closest('[hidden]') && /cookie/i.test(el.textContent || ''),
    );
    ownItem.hidden = injected;
  }

  #onCommand(event) {
    if (event.command !== '--show-preferences') return;
    const banner = window.privacyBanner;
    if (banner && typeof banner.showPreferences === 'function') {
      banner.showPreferences();
      return;
    }
    const fallback = this.dataset.fallbackUrl;
    if (fallback) window.location.href = fallback;
  }
}

customElements.define('s-cookie-preferences', SCookiePreferences);
